import DealerTextEditor from './DealerTextEditor';

export default DealerTextEditor;
